

<script>
import { defineComponent } from "vue";
import { VideoPlayer } from "@videojs-player/vue";
import "video.js/dist/video-js.css";

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    streamer: {},
    video: {},
  },
  methods: {
    handleMounted(player) {
      // Lógica quando o componente é montado
    },
    handleEvent(event) {
      // Lógica para lidar com eventos do player
      //   console.log("Evento:", event.type);
    },
    handleTimeUpdate(currentTime) {
      // Lógica para lidar com o evento de atualização do tempo
      //   console.log("Tempo Atual:", currentTime);
    },
  },
});
</script>

<template>
  <div class="content">
    <video-player
      class="video-player vjs-big-play-centered"
      :src="video.src"
      crossorigin="anonymous"
      playsinline
      controls
      :volume="0.6"
      :height="320"
    />

    <a :href="streamer.link" target="_blank" class="card">
      <div class="backgroundCard"></div>
      <div v-if="streamer.icone" class="icone">
        <img :src="streamer.icone" alt="Icone do streamer" />
      </div>
      <div>
        <h3>{{ streamer.name }}</h3>
        <h4>{{ streamer.linkName }}</h4>
      </div>
    </a>
  </div>
</template>

<style>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video-js {
  border-radius: 25px;
  overflow: hidden;
  min-width: calc(500px - 1rem);
}

.video-js .vjs-play-progress:before,
.vjs-slider-horizontal .vjs-volume-level:before {
  top: -9px;
}

.vjs-icon-play:before,
.video-js .vjs-play-control .vjs-icon-placeholder:before,
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal,
.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,
.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,
.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal,
.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,
.video-js
  .vjs-volume-panel.vjs-hover
  .vjs-mute-control
  ~ .vjs-volume-control.vjs-volume-horizontal,
.vjs-volume-panel .vjs-mute-control ~ .vjs-volume-control.vjs-volume-horizontal,
.video-js
  .vjs-volume-panel
  .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal {
  transform: rotate(-90deg) translate(50px, -70px) !important;
  transition: var(--slow);
}

.video-js .vjs-progress-control {
  cursor: default;
}

.video-js .vjs-progress-control > * {
  display: none;
}

.card {
  min-width: 300px;
  display: flex;
  margin: -45px auto 0px;
  position: relative;
  z-index: 1;
  border-radius: 20px;
  border: 1.6px solid rgba(255, 255, 255, 0.3);
  text-align: left;
  padding: 15px;
  overflow: hidden;
  transform: skewX(-15deg);
  gap: 1rem;
  transition: 0.8s linear;
}

.card:hover {
  animation: growingBorder 2s ease-in-out infinite;
}

@keyframes growingBorder {
  0% {
    border-width: 1px;
  }
  50% {
    border-width: 10px;
  }
  100% {
    border-width: 1px;
  }
}

.backgroundCard {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    165deg,
    rgba(252, 255, 17, 0%) 60%,
    rgba(255, 255, 255, 18%) 100%
  );
  backdrop-filter: blur(22px);
  z-index: -1;
}

.card h3 {
  font-size: 20px;
  margin-bottom: 0.5rem;
}

.card::after {
  content: "";
  display: none;
}

.icone {
  width: 67px;
  height: 67px;
  overflow: hidden;
  border-radius: 10px;
}

.icone img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
}

@media screen and (max-width: 995px) {
  .video-js {
    max-width: 764px;
    width: calc(100% - 1rem);
  }

  .content {
    width: 100%;
  }
}
@media screen and (max-width: 650px) {
  .video-js .vjs-control-bar {
    bottom: 50px;
  }

  .video-js .vjs-progress-control,
  .video-js .vjs-picture-in-picture-control {
    display: none;
  }

  .video-js .vjs-fullscreen-control {
    margin-left: auto;
  }
}
</style>
